export const EXCLUDED_KEYS = [
  'branch_views',
  'builder',
  'id',
  'number_of_use',
  'priority',
  'status',
  'query'
];

export const QUICK_LINKS_DATASOURCES = [
  'eo_click',
  'eo_install',
  'eo_open',
  'eo_reinstall',
  'eo_web_session_start',
  'eo_custom_event',
  'eo_commerce_event',
  'eo_user_lifecycle_event',
  'eo_content_event'
];
